<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#1C2147" stroke="rgba(255, 255, 255, 0.15)" stroke-width="1" />
  <rect x="5" y="6" width="7" height="5" rx="1" fill="#FFA100" />
  <line x1="5" y1="18" x2="22" y2="18" stroke="rgba(255, 255, 255, 0.5)" stroke-width="1.5" stroke-linecap="round" />
  <line x1="26" y1="18" x2="35" y2="18" stroke="rgba(255, 255, 255, 0.3)" stroke-width="1.5" stroke-linecap="round" />
</svg>
